import generateParseObject from "./common/parse/ParseObjectFactory";
import {toJSONList, toJSON} from "./common/parse/helper/parse";
import * as  axios from "axios";
import UsersService from "./Users";
import * as _ from "lodash";
import * as moment from "moment"
import { toJS } from "mobx";
const ReportObj = generateParseObject("v5_report");
const ReportStepObj = generateParseObject("v5_student_task");
const StudentTaskReportObj = generateParseObject("v5_student_task_report");
const TaskTagsObj = generateParseObject("v5_score_item_task_tag");
const TaskObj = generateParseObject("v5_score_item_task");
const Parse = window.Parse;
const getData = (resp) => resp.data;

export default class Users {

    static getReportsByBoxId(boxId, author) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('author', author);
        query.containedIn('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.select('status');
        query.limit(9999);
        return query.find().then(toJSONList)
    }

    static getStudentReportsByBoxIdAndUserName(students,boxId) {
        // const query = new Parse.Query(StudentTaskReportObj);
        // query.equalTo('username', userName);
        // query.equalTo('boxId', boxId);
        // query.notEqualTo('isDeleted', true);
        // query.limit(9999);
        // return query.find().then(toJSONList)
        return axios.post("/teacher/report/getStudentReportsByBoxIdAndUserName", {students,boxId}).then(getData);
    }

    static getBoxReports(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.limit(9999);
        return query.find().then(toJSONList)
    }
    static async fetchLatestReportsByBoxId(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        if(!window.config.is_use_xcx){
            query.startsWith('status', '已提交');
        }
        query.notEqualTo('isDeleted', true);
        // query.select(['score_item','author','updatedAt','status','r_score','score','score_time','scoreTeacher','backupUrl','boxId','name','fileUrl','chaChong','backReason','backCount','attachmentUrl','attachmentName','uploadTime','submittedTime','raw_fileUrls','image_file_urls']);
        query.limit(9999);
        const _reports=await query.find().then(toJSONList);
        const reports=_reports.map(report=>{
            const time=moment(report.updatedAt).unix();
            return {...report,time}
        });
        //根据score_item和username分组，得到学生每个评分项提交的报告
        const reportGroup=_.groupBy(reports,report => {
            return report.score_item+"_"+report.author
        });
        const userAndItems=Object.keys(reportGroup);
        //根据提交时间，时间戳值最大的为最新提交的报告
        const latestReports=userAndItems.map(itemAndUser=>{
            const userReports=reportGroup[itemAndUser];
            const latestReport=_.maxBy(userReports,'time');
            return{...latestReport}
        });
        return latestReports
    }


    static async fetchStepReportsByBoxId(boxId){
        return axios.post("/teacher/report/getTaskReports", {boxId}).then(getData);

        // const query = new Parse.Query(StudentTaskReportObj);
        // query.equalTo('boxId', boxId);
        // // query.startsWith('status', '已提交');
        // query.notEqualTo('isDeleted', true);
        // // query.notEqualTo('isHide', true);
        // query.limit(9999);
        // return await query.find().then(toJSONList)
    }

    static getReportsByIds(ids){
        const query = new Parse.Query(ReportObj);
        query.containedIn('objectId', ids);
        query.notEqualTo('isDeleted', true);
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }


    static getUserReports(boxId, author) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('author', author);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getUserTaskReports(boxId, author) {
        const query = new Parse.Query(StudentTaskReportObj);
        query.equalTo('username', author);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        // query.notEqualTo('isHide', true);
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }


    static getSubmittedReport(score_item,boxId,user) {
        const query = new Parse.Query(StudentTaskReportObj);
        query.equalTo('score_item',score_item);
        query.equalTo('boxId',boxId);
        query.equalTo('username',user);
        query.notEqualTo('isDeleted', true);
        query.descending('submittedTime');
        return query.find().then(toJSONList).catch(e=>[]);
    }


    static getSubmitStepReportCount(score_item,boxId,user){
        const query = new Parse.Query(StudentTaskReportObj);
        query.equalTo('score_item',score_item);
        query.equalTo('boxId',boxId);
        query.notEqualTo('isDeleted', true);
        query.equalTo('username',user);
        query.startsWith('status', '已提交');
        return query.count()
    }

    static getTaskReport(reportId){
        return StudentTaskReportObj.getOne(reportId)
    }

    static getTasksByReportId(reportId){
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('reportId',reportId);
        query.notEqualTo('isDeleted', true);
        query.equalTo('isSubmitted', true);
        return query.find().then(toJSONList);
    }

    static getTasksByReportIds(reportIds){
        const query = new Parse.Query(ReportStepObj);
        query.containedIn('reportId',reportIds);
        query.notEqualTo('isDeleted', true);
        query.equalTo('isSubmitted', true);
        return query.find().then(toJSONList);
    }

    

    static getSubmittedReports(boxId) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.startsWith('status', '已提交');
        query.notEqualTo('isDeleted', true);
        query.ascending('submittedTime');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }


    static getSubmittedStepReports(boxId) {
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('boxId', boxId);
        query.startsWith('status', '已提交');
        query.notEqualTo('isDeleted', true);
        query.ascending('submittedTime');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getSubmittedReportsCount(boxId) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.startsWith('status', '已提交');
        query.notEqualTo('isDeleted', true);
        return query.count();
    }

    static getScoreReportsCount(boxId) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.equalTo('status', '已提交/已批改');
        query.notEqualTo('isDeleted', true);
        return query.count();
    }

    static getStepReportsCount(boxId) {
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('boxId', boxId);
        query.equalTo('status', '已提交/已批改');
        query.notEqualTo('isDeleted', true);
        return query.count();
    }

    static getBoxReportsCountByItem(boxId,name){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.equalTo('score_item', name);
        query.notEqualTo('isDeleted', true);
        return query.count();
    }

    static addReport(score_item, status, boxId) {
        return axios.post("/student/report/add", {score_item, status, boxId}).then(getData);
    }

    static updateReport(key, value, id) {
        return axios.post("/student/report/update", {key,value,id}).then(getData);
    }

    static deleteTask(boxId,score_item,key,value){ 
        return axios.post("/student/report/deleteTask", {boxId,score_item,key,value}).then(getData);
    }

    static uploadReport(fileUrl, name,score_item,boxId,reportType,reportId){
        return axios.post("/student/report/upload", {fileUrl, name,score_item,boxId,reportType,reportId}).then(getData);
    }
    

    static removeReportFile(reportId){
        return axios.post("/student/report/remove_report_file", {reportId}).then(getData);
    }
    static  addReportAttachment(reportId,attachmentUrl,attachmentName){
        return axios.post("/student/report/add_attachment", {reportId,attachmentUrl,attachmentName}).then(getData);
    }

    static removeAttachmentFile(reportId){
        return axios.post("/student/report/remove_attachment", {reportId}).then(getData);
    }

    static saveScore(report) {
        // {
        //     author: "stu2"
        //     boxId: "kz3JsX7D2N"
        //     createdAt: "2021-12-21T06:26:10.461Z"
        //     fileUrl: "/file/1uROOUYqoz"
        //     name: "实验1.pdf"
        //     score: 3.5
        //     score_item: "作业一"
        //     status: "已提交/已批改"
        //     submittedTime: {
        //         __type: 'Date', iso
        //     :
        //         '2021-12-21T07:51:27.246Z'
        //     }
        //     summmary_comment: "做的不错"
        //     updatedAt: "2021-12-21T07:51:27.973Z"
        //     _id: "Rf9NrqdoPb"
        // }
        return axios.post("/teacher/report/save_score", {report}).then(getData);
    }

    static saveReportTaskScore(report) {
        return axios.post("/teacher/report/save_task_score", {report}).then(getData);
    }



    static backupPdfFile(reportId){
        return axios.get(`/pdf/backup/${reportId}`).then(getData);
    }

    static saveRScore(boxId,r_score,username,score_item){
        console.log("boxId,r_score,username,score_item",boxId,r_score,username,score_item)
        return axios.post("/teacher/report/save_r_score", {boxId,r_score,username,score_item}).then(getData);
    }

    static backReport(backReason, id) {
        return axios.post("/teacher/report/back_report", {backReason, id}).then(getData);
    }

    static backTaskReport(backReason, id) {
        return axios.post("/teacher/report/back_task_report", {backReason, id}).then(getData);
    }

    static updateReportTask(key, value, taskId) {
        return axios.post("/student/report_box/update_task", {key,value,taskId}).then(getData);
    }

    static sendBackReportMsg(phoneNumber,reportId,boxName,score_item,backReason) {
        return axios.post("/teacher/ali_msg/back_report", {phoneNumber,reportId,boxName,score_item,backReason}).then(getData).catch(e=>{
            return {error:"发送退回报告通知短信失败："+e.data.error};
        });
    }

    static async fetchReportsByBoxIdWithOrder(boxId, orderField, orderMethod,scoreItem) {
        //console.log('boxId, orderField, orderMethod,scoreItem',boxId, orderField, orderMethod,scoreItem);
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.startsWith('status', '已提交');
        query.notEqualTo('isDeleted', true);
        if (orderMethod) {
            if (orderMethod === "ascend") {
                query.ascending(orderField);
            } else {
                if(orderField==='username'){
                    query.descending('author');
                }else{
                    query.descending(orderField);
                }
            }
        }
        // else {
        //     query.ascending('submittedTime');
        // }
        if(scoreItem){
            query.equalTo('score_item', scoreItem);
        }
        query.limit(9999);
        return query.find().then(toJSONList);
    }

    static getReportsFromBackup(boxId){
        //`这个页面是从作业箱页面进去的，作业箱作业列表肯定有备份`
        const sBoxesData = window.sessionStorage.getItem('boxesData');
        var boxesData = {};
        if(sBoxesData){
            boxesData = JSON.parse(sBoxesData);
        }else{
            return [];
        }
        const reports = boxesData[boxId]||[];
        return reports;
    }

    static async getReportsByBoxIdWithOrderFromNewArray(boxId, orderField, orderMethod, scoreItem) {
        var reports = await this.getSubmittedReports(boxId);
        console.log('1 reports',reports)
        if (scoreItem) {
            reports = reports.filter(report => report.score_item === scoreItem);
        }
        console.log('2 reports',reports)
        const authors = reports.map(r => r.author);
        const authorsInfo = await UsersService.getUsersByUsernames(authors);
        const authorDict = _.keyBy(authorsInfo, 'username');
        const scoreTeachers = reports.map(r => r.scoreTeacher);
        const scoreTeachersInfo = await UsersService.getUsersByUsernames(scoreTeachers);
        const scoreTeacherDict = _.keyBy(scoreTeachersInfo, 'username');
        const newReports = [];
        for(var i=0;i<reports.length;i++){
            const report = reports[i];
            console.log('for report',report)
            const author = authorDict[report.author] || {};
            const scoreTeacher = scoreTeacherDict[report.scoreTeacher] || {};
            const newReport =  {
                ...report,
                username: author.username,
                showName: author.showName,
                studentNumber: author.studentNumber === 'NA' ? author.username : author.studentNumber,
                scoreTeacher: scoreTeacher.showName
            }
            newReports.push(newReport);
        }
        console.log('3 reports',newReports)
        if (orderMethod) {
            if (orderMethod === "ascend") {
                newReports.sort((a,b)=>a[orderField]<b[orderField]?-1:a[orderField]>b[orderField]?1:0)
            } else {
                newReports.sort((a,b)=>a[orderField]<b[orderField]?1:a[orderField]>b[orderField]?-1:0)
            }
        }
        console.log('4 reports',newReports)
        return newReports;
    }

    static getReportsByUsernameWithBoxId(author,boxId) {
        const query = new Parse.Query(ReportObj);
        query.equalTo('author', author);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.notEqualTo('status', '未上传');
        query.limit(9999);
        return query.find().then(toJSONList)
    }

    static getUserReportScoreByBoxId(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        // query.exists('score');//数据库里字段为null还是会筛过来
        // query.notEqualTo('score', null);
        // query.equalTo('status', '已提交/已批改');
        query.select("score_item",'author','score','r_score');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getUserScoredReportsByBoxId(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.exists('score');//数据库里字段为null还是会筛过来
        query.notEqualTo('score', null);
        query.equalTo('status', '已提交/已批改');
        query.select("score_item",'author','score','r_score');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }



    static getUserStepReportScoreByBoxId(boxId){
        console.log("getUserStepReportScoreByBoxId",boxId)
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.equalTo('status', '已提交/已批改');
        query.select("score_item",'author','score',);
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }


    static getUserStepTaskReportScoreByBoxId(boxId) {
        console.log("getUserStepReportScoreByBoxId", boxId);
        const query = new Parse.Query(StudentTaskReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.equalTo('status', '已提交/已批改');
        query.limit(9999);
        return query.find().then(toJSONList);
    }


    static getStudentReportByBoxId(boxId,score_item) {
        const query = new Parse.Query(StudentTaskReportObj);
        query.equalTo('boxId', boxId);
        query.equalTo('score_item', score_item);
        query.notEqualTo('isDeleted', true);
        // query.equalTo('status', '已提交/已批改');
        query.limit(9999);
        return query.find().then(toJSONList);
    }


    // static getTaskByBoxId(boxId) {
    //     const query = new Parse.Query(TaskObj);
    //     query.equalTo('boxId', boxId);
    //     query.notEqualTo('isDeleted', true);
    //     // query.equalTo('status', '已提交/已批改');
    //     query.limit(9999);
    //     return query.find().then(toJSONList);
    // }





    static getSelectedScoreItemReports(boxId,score_item){
        console.log("getSelectedScoreItemReports",boxId,score_item)
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.equalTo('score_item', score_item);
        query.notEqualTo('isDeleted', true);
        query.exists('r_score');//数据库里字段为null还是会筛过来
        query.select("score_item",'author','r_score');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getSelectedScoreItemStepReports(boxId,score_item){
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('boxId', boxId);
        query.equalTo('score_item', score_item);
        query.notEqualTo('isDeleted', true);
        query.select("score_item",'author','score');
        query.limit(9999);
        return query.find().then(toJSONList).catch(e=>[]);
    }

    static getBackReportByBoxId(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.greaterThanOrEqualTo('backCount',1);
        query.limit(9999);
        return query.count().catch(e=>0);
    }

    static getReportsWithoutUser(scoreItem,boxId,user){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.equalTo('score_item', scoreItem);
        query.notEqualTo('isDeleted', true);
        query.notEqualTo('author', user);
        query.startsWith('status', '已提交');
        query.limit(9999);
        return query.find().then(toJSONList)
    }

    static getReportById(id){
        return ReportObj.getOne(id)
    }

    static getBackupedReportsByBoxId(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.notEqualTo('backupUrl', null);
        query.limit(9999);
        return query.find().then(toJSONList)
    }
    //获取最新批改过的报告
    static getLatestScoreReport(boxId){
        const query = new Parse.Query(ReportObj);
        query.equalTo('boxId', boxId);
        query.notEqualTo('isDeleted', true);
        query.descending("score_time");
        return query.first().then(toJSON)
    }

    static startAIMark(report,ai_score_type){
        return axios.post('/teacher/report/ai_score', {report,ai_score_type})
            .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }

    static getAIMarkResult(reportId){
        return axios.post(`/teacher/report/ai_result`, {reportId})
            .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }

    static getStepAiMarkResult(reportId){
        return axios.post(`/teacher/report/step_ai_result`, {reportId})
        .then(getData).catch(e=>{return {status:false,message:"服务异常:"+e.message}})
    }


    //全局标签
    static addTag(tagName,parentId) {
        return axios.post(`/teacher/report/addTag`, {tagName,parentId}).then(getData)
    }

    static updateTag(id,tagName,parentId) {
        return axios.post(`/teacher/report/updateTag`, {id,tagName,parentId}).then(getData)
    }
    static deleteTags(ids) {
        return axios.post(`/teacher/report/deleteTags`, {ids}).then(getData)
    }
    static async getAllTags() {
        const query = new Parse.Query(TaskTagsObj);
        query.ascending("createdAt"); // 根据创建时间排序
        query.notEqualTo("isDeleted", true); // 过滤掉被删除的标签
        query.limit(9999); // 设置最大查询数量
        const tags = await query.find(); // 获取所有标签
        const tagMap = {}; // 用于存储标签的映射
        // 构建一个标签映射，用于快速查找父类名称
        tags.forEach(tag => {
            tagMap[tag.id] = tag;
        });
        // 为每个标签添加父类名称
        const tagsWithParentName = tags.map(tag => {
            const parentName = tag.parentId && tagMap[tag.parentId]
                ? tagMap[tag.parentId].get("tagName") // 获取父类名称
                : "0"; // 如果没有父类或父类不存在，显示“0”
    
            return {
                ...tag.toJSON(),
                parentName: parentName // 添加父类名称字段
            };
        });
    
        return tagsWithParentName;
    }

    static async getTagsById(id) {
        try {
            const query = new Parse.Query(TaskTagsObj);
            query.equalTo("objectId", id); 
            const result = await query.first().then(toJSON); // 获取第一个匹配的标签
            console.log(toJS(result))
            // 提取标签名称和其他需要的字段
            if (result) {
                const tag = {
                    id: result._id||result.objectId,
                    tagName: result.tagName,
                    parentId: result.parentId,
                };
                return tag;
            } else {
                return null;
            }
        } catch (error) {
            console.error("Error fetching tag by ID:", error);
            return null;
        }
    }


    static async getTagsByParentId(parentId) {
        try {
            const query = new Parse.Query(TaskTagsObj);
            query.equalTo("parentId", parentId);
            const results = await query.find(); // 获取所有匹配的子标签
    
            // 提取标签名称和其他需要的字段
            const tags = results.map((tag) => ({
                id: tag.id,
                tagName: tag.get("tagName"),
                parentId: tag.get("parentId"),
            }));
            return tags;
        } catch (error) {
            console.error("Error fetching tags by parent ID:", error);
            return [];
        }
    }


    


    static async getTagsByIds(ids) {
        if (!Array.isArray(ids) || ids.length === 0) {
            return []; 
        }
        try {
            const query = new Parse.Query(TaskTagsObj);
            query.containedIn("objectId", ids); 
            const results = await query.find(); 
            // 提取标签名称和其他需要的字段
            const tags = results.map((tag) => ({
                id: tag.id,
                tagName: tag.get("tagName"), 
            }));
            return tags;
        } catch (error) {
            console.error("Error fetching tags by IDs:", error);
            return [];
        }
    }

    static async getTagsInfoByIds(ids) {
        if (!Array.isArray(ids) || ids.length === 0) {
            return [];
        }
        try {
            const query = new Parse.Query(TaskTagsObj);
            query.containedIn("objectId", ids);
            const results = await query.find();
    
            // 提取标签名称、parentId 和其他需要的字段
            const tags = await Promise.all(results.map(async (tag) => {
                const parentId = tag.get("parentId");
                let parentTagName = null;
    
                if (parentId) {
                    const parentQuery = new Parse.Query(TaskTagsObj);
                    const parentTag = await parentQuery.get(parentId);
                    parentTagName = parentTag.get("tagName");
                }
    
                return {
                    id: tag.id,
                    tagName: tag.get("tagName"),
                    parentId: parentId,
                    parentTagName: parentTagName
                };
            }));
    
            return tags;
        } catch (error) {
            console.error("Error fetching tags by IDs:", error);
            return [];
        }
    }


    // static async getTagsGroupByIds(ids) {
    //     if (!Array.isArray(ids) || ids.length === 0) {
    //         return []; 
    //     }
    //     try {
    //         const query = new Parse.Query(TaskTagsObj);
    //         query.containedIn("objectId", ids); 
    //         const results = await query.find(); 
    //         console.log("results", results);
    
    //         // 提取标签名称和其他需要的字段，并根据 parentID 进行分类
    //         const tagsByParent = {};
    //         const parentIds = new Set();
    
    //         results.forEach((tag) => {
    //             const parentID = tag.get("parentId");
    //             const tagData = {
    //                 id: tag.id,
    //                 tagName: tag.get("tagName"),
    //             };
    
    //             if (!tagsByParent[parentID]) {
    //                 tagsByParent[parentID] = [];
    //             }
    //             tagsByParent[parentID].push(tagData);
    //             parentIds.add(parentID);
    //         });
    
    //         // 获取父标签的名称
    //         const parentQuery = new Parse.Query(TaskTagsObj);
    //         parentQuery.containedIn("objectId", Array.from(parentIds));
    //         const parentResults = await parentQuery.find();
    
    //         const parentNames = {};
    //         parentResults.forEach((parent) => {
    //             parentNames[parent.id] = parent.get("tagName");
    //         });
    
    //         // 转换 tagsByParent 为所需格式
    //         const groupedTags = Object.entries(tagsByParent).map(([parentId, children]) => ({
    //             parentId,
    //             parentName: parentNames[parentId] || "未知父标签",
    //             children,
    //         }));
    
    //         return groupedTags;
    //     } catch (error) {
    //         console.error("Error fetching tags by IDs:", error);
    //         return [];
    //     }
    // }
    // static async getTagsByIds(ids) {
    //     if (!Array.isArray(ids) || ids.length === 0) {
    //         return [];
    //     }
    // }

    static async sendTagsDataFile(dataFile,fieldsMapping){
        const formdata = new FormData();
        formdata.append('file',dataFile);
        formdata.append('fieldsMapping',fieldsMapping);
        return axios.post('/teacher/report/addTag/check_file',formdata).then(getData)
}
    //任务型作业
    static getOrCreateStudentTask(boxId,score_item){
        return axios.post("/student/report/get_or_create_tasks", {boxId,score_item}).then(getData);
    }
    //获取当前任务
    static getTask(taskId){
        return ReportStepObj.getOne(taskId)
    }

    static getSubmittedCount(reportId,index){
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('reportId', reportId);
        query.equalTo('index', index);
        query.exists('isSubmitted');
        query.notEqualTo('isBack', true);
        return query.count()
    }

    static getSubmittedTasks(reportId,index){
        console.log("getSubmittedTasks",reportId,index)
        const query = new Parse.Query(ReportStepObj);
        query.equalTo('reportId', reportId);
        query.equalTo('index', index);
        query.exists('isSubmitted');
        query.notEqualTo('isBack', true);
        query.descending('createdAt');
        return query.find().then(toJSONList)
    }

    static getReportSubmittedTasks(reportId){
        const query1 = new Parse.Query(ReportStepObj);
        query1.equalTo('isSubmitted', true);
        const query2 = new Parse.Query(ReportStepObj);
        query2.doesNotExist('isSubmitted');
        const query = Parse.Query.or(query1, query2);
        query.equalTo('reportId', reportId);
        query.notEqualTo('isDeleted', true);
        query.notEqualTo('isBack', true);
        return query.find().then(toJSONList)
    }

    static updateStudentTask(key,value,taskId){
        return axios.post("/student/report/update_task", {key,value,taskId}).then(getData);
    }

    static updateStudentTaskForTeacher(key,value,taskId){
        return axios.post("/teacher/report/update_task", {key,value,taskId}).then(getData);
    }


    


    static updateStudentTaskReport(key,value,reportId){
        return axios.post("/student/report/update_step_report", {key,value,reportId}).then(getData);
    }

    static submitStepTask(task){
        return axios.post("/student/report/submit_step_task", {task}).then(getData);
    }
    
    static updateEditTask(key,value,id){
        // delete task.submittedCount
        return axios.post("/student/report/update_edit_task", {key,value,id}).then(getData);
    }
}